import { useDialogos } from '@/shared/ui/DialogosProvider';
import type { SugestaoTexto } from '@/features/pos-venda/textosSugeridos';

/**
 * Linha "Usar sugestão: Cordial · Direta · …" acima de um editor de
 * mensagem. A opção igual ao texto atual fica marcada e desabilitada.
 * Trocar um texto já escrito (que não seja uma das sugestões) pede
 * confirmação antes — o atendente não perde o que digitou sem querer.
 */
export function SugestoesTexto({
  sugestoes,
  texto,
  onTexto,
  dica,
}: {
  sugestoes: SugestaoTexto[];
  texto: string;
  onTexto: (t: string) => void;
  dica?: string;
}) {
  const dialogos = useDialogos();
  if (sugestoes.length === 0) return null;

  const atual = texto.trim();
  const ehSugestao = sugestoes.some((s) => s.texto.trim() === atual);

  async function usar(s: SugestaoTexto) {
    if (atual && !ehSugestao) {
      const ok = await dialogos.confirmar({
        titulo: 'Substituir mensagem?',
        mensagem: `O texto atual será trocado pela sugestão "${s.rotulo}". O que você escreveu será perdido.`,
        textoConfirmar: 'Substituir',
        textoCancelar: 'Manter meu texto',
      });
      if (!ok) return;
    }
    onTexto(s.texto);
  }

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 6, marginTop: 8 }}>
      {dica && (
        <span className="hint" style={{ margin: 0, flex: '1 1 100%' }}>
          {dica}
        </span>
      )}
      <span className="hint" style={{ margin: 0, fontSize: 12 }}>
        Usar sugestão:
      </span>
      {sugestoes.map((s) => {
        const marcada = s.texto.trim() === atual;
        return (
          <button
            key={s.rotulo}
            type="button"
            className="btn btn--ghost"
            style={{
              fontSize: 12,
              padding: '2px 10px',
              ...(marcada
                ? { borderColor: 'var(--color-primary)', color: 'var(--color-primary)', opacity: 1 }
                : null),
            }}
            disabled={marcada}
            aria-pressed={marcada}
            title={marcada ? 'Esta sugestão já está em uso' : s.texto}
            onClick={() => void usar(s)}
          >
            {marcada ? `✓ ${s.rotulo}` : s.rotulo}
          </button>
        );
      })}
    </div>
  );
}
